var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page-title',{attrs:{"titleText":_vm.pageTitle}}),_c('service-predict-form',{attrs:{"formType":_vm.formType,"service":_vm.service},on:{"setService":_vm.updateService,"deleteService":_vm.deleteService,"cancel":_vm.goToServicesPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }